import React from 'react';
import TreeNode from '../TreeNode/TreeNode';
import useTrimStore from '../../store/trimStore';

const TreeView = () => {
  const { treeData, toggleNode, checkedNodes } = useTrimStore();

  console.log('🔥 [DEBUG] TreeView 렌더링 - treeData:', treeData);
  console.log('🔥 [DEBUG] TreeView 렌더링 - toggleNode:', typeof toggleNode);

  if (!treeData) {
    console.log('🔥 [DEBUG] TreeView - treeData가 없음');
    return <div>트리 데이터가 없습니다.</div>;
  }

  return (
    <div>
      <TreeNode 
        node={treeData} 
        isRoot={true}
        onToggle={toggleNode}
        checkedNodes={checkedNodes}
      />
    </div>
  );
};

export default TreeView;